export default function Container({ children }) {
  return (
    <div className="container mx-auto max-w-6xl py-8 px-4">{children}</div>
  );
}
